import { service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class CapacityInitiativesTableIndexComponent extends Component {
  @service initiativeSlideover;
  @service intl;
  @service store;

  @tracked groupedInitiatives = {};

  @action
  initiatives() {
    this.groupInitiatives();
    return '';
  }

  @action
  person_weeks_excluding_uncertainty_for(field, id, initiative) {
    if (id == 'unassigned') id = undefined;

    const field_id = `${field}_id`;
    let pw = 0;
    const investments = initiative.bon.get('investments');

    if (investments !== undefined) {
      investments?.calculations?.forEach((calculation) => {
        if (calculation[field_id] == id) {
          pw +=
            (calculation.people ?? 1) *
            (calculation.weeks ?? 1) *
            (calculation.person_weeks ?? 1);
        }
      });
    }

    return pw;
  }

  @action
  person_weeks_uncertainty_for(field, id, initiative) {
    if (id == 'unassigned') id = undefined;
    const field_id = `${field}_id`;
    let pw = 0;
    const investments = initiative.bon.get('investments');

    if (investments !== undefined) {
      investments?.calculations?.forEach((calculation) => {
        if (calculation[field_id] == id) {
          pw +=
            (calculation.people ?? 1) *
            (calculation.weeks ?? 1) *
            (calculation.person_weeks ?? 1) *
            (calculation.confidence_value - 1);
        }
      });
    }

    return pw;
  }

  @action
  async groupInitiatives() {
    const record_type = this.args.capacity_type;
    const id_field = `${record_type}_id`;

    const groupedInitiatives = {
      unassigned: {
        label: this.intl.t('dictionary.unspecified'),
        data: new Set([]),
      },
    };

    const initiatives = await this.args.initiatives;
    for (let index = 0; index < initiatives.length; index++) {
      const initiative = initiatives[index];
      try {
        const bon = await this.store
          .findRecord('bon', initiative.id)
          .catch(() => undefined);
        if (bon?.investments == undefined) {
          groupedInitiatives.unassigned.data.add(initiative);
          continue;
        }

        bon.investments.calculations.forEach((c) => {
          const id = c[id_field];
          if (id) {
            if (!groupedInitiatives[id]) {
              const object = this.store.peekRecord(record_type, id);
              groupedInitiatives[id] = {
                label: object?.name ?? `${record_type} not Found`,
                data: new Set([initiative]),
              };
            } else {
              groupedInitiatives[id]?.data?.add(initiative);
            }
          } else {
            groupedInitiatives.unassigned.data.add(initiative);
          }
        });
      } catch (error) {
        console.debug(error);
      }
    }

    this.groupedInitiatives = groupedInitiatives;
  }
}
